import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import EditSettingForm from "./Componates/EditSettingForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import feilds from "../json/SettingFeilds.json";
import { validateForm } from "utils/validation";
import { ParkingSettingRules } from "validation/ValidationRules";
import {
  Update,
  GetById,
  GetAllZonesTypes,
  GetAllVehicleType,
  GetAllTaxOptions,
} from "adminApi/ParkingSettingApi/ParkingSetting.js";

const EditSetting = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = feilds;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Initialize form values
  const {
    values,
    errors,
    handleChange,
    setValues,
    setErrors
  } = useFormChange(
    initialValues,
    ParkingSettingRules
  );

  // Fetch existing data by ID
  const {
    loading: loadingFetch
  } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  //Get Vehicle Type
  const {
    data: VehicleTypeOptions,
    loading: loadingVehicleTypeOptions
  } = useFetchAllData(
    GetAllVehicleType
  );

  //Get Zones Types
  const {
    data: ZonesTypesOptions,
    loading: loadingZonesTypesOptions
  } = useFetchAllData(
    GetAllZonesTypes
  );

  // Get Tax Options
  const {
    data: TaxOptions,
    loading: loadingTaxOptions
  } = useFetchAllData(
    GetAllTaxOptions
  );

  // Form submit hook
  const {
    loading: loadingSubmit,
    handleSubmit
  } = useFormSubmit(
    async (formValues) => {
      return await Update({ id, data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, ParkingSettingRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Setting updated successfully"
  );

  return (

    <>
      {(
        loadingFetch ||
        loadingSubmit ||
        loadingVehicleTypeOptions ||
        loadingZonesTypesOptions ||
        loadingTaxOptions
      ) && <Spinner isSpinner={true} />
      }
      <EditSettingForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Setting"
        VehicleTypeOptions={VehicleTypeOptions}
        ZonesTypesOptions={ZonesTypesOptions}
        TaxOptions={TaxOptions}
      />
    </>
  );
};

export default EditSetting;
